// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    subheading: {
        id: 'manage-device.subheading',
        defaultMessage: 'Please try the following steps in order'
    },
    step1: {
        id: 'manage-device.step1',
        defaultMessage: "Unplug your hub's power supply and plug back in again"
    },
    step2: {
        id: 'manage-device.step2',
        defaultMessage: 'Check your device has power, is turned on or has batteries'
    },
    step3: {
        id: 'manage-device.step3',
        defaultMessage: 'When the hub lights stop flashing, tap refresh'
    },
    note: {
        id: 'manage-device.note',
        defaultMessage: 'Note: you will still be able to control any connected devices from the menu'
    },
    refresh: {
        id: 'manage-device.refresh',
        defaultMessage: 'Refresh'
    },
    extendedSupport: {
        id: 'manage-device.extended-support',
        defaultMessage: 'If the above steps have not helped please check {hiveHomeLink} for our support hours.'
    },
    checkPlug: {
        id: 'manage-device.check-plug',
        defaultMessage:
            'Check the plug has power by confirming the wall socket is on, if not, turn it on, wait a couple of minutes and press refresh'
    },
    checkPower: {
        id: 'manage-device.check-power',
        defaultMessage:
            'If you have other Hive devices, check they are all powered by turning them on at the light switch or wall socket, wait a couple of minutes and press refresh'
    },
    turnPlugOff: {
        id: 'manage-device.turn-plug-off',
        defaultMessage:
            'Turn the affected plug off and back on again at the wall socket, wait a couple of minutes and press refresh'
    },
    checkPlacement: {
        id: 'manage-device.check-placement',
        defaultMessage: 'Check your Hive Hub is placed correctly by following the guide {link}'
    },
    turnOffOn: {
        id: 'manage-device.turn-off-on',
        defaultMessage:
            'At your Hive Hub turn it off and back on again at the wall socket, wait 10 minutes and press refresh'
    },
    checkLight: {
        id: 'manage-device.check-light',
        defaultMessage:
            'Check the affected light has power by confirming the light switch or wall socket is on, if not, turn it on, wait a couple of minutes and press refresh'
    },
    checkBridge: {
        id: 'manage-device.check-bridge',
        defaultMessage: 'Check that your Philips Hue bridge is powered and connected to your router'
    },
    contactPhilips: {
        id: 'manage-device.contact-philips',
        defaultMessage: 'In the Hue app if you’re unable to control your lights please contact Philips Hue for support.'
    },
    'remove-Philips': {
        id: 'manage-device.remove-philips',
        defaultMessage: 'Delete Philips Hue'
    },
    turnLightOffOn: {
        id: 'manage-device.turn-light-off-on',
        defaultMessage:
            'Turn the affected light off and back on again at the light switch or wall socket, wait a couple of minutes and press refresh'
    },
    openSensorCase: {
        id: 'manage-device.open-sensor-case',
        defaultMessage:
            'On the sensor press the side markings and pull open the case. Remove and then reinsert the battery, wait a couple of minutes and press refresh'
    },
    pressBackButton: {
        id: 'manage-device.press-back-button',
        defaultMessage:
            'Press the back button on the thermostat to ensure the device has power, if not, replace the batteries and wait a couple of minutes then press refresh'
    },
    callUs: {
        id: 'manage-device.call-us',
        defaultMessage:
            'If there is no light on the boiler module with the power switched on, you need to call us on the number below (click refresh). If you have a green light, please turn the mains power switch for the boiler off and back on, wait a couple of minutes and press refresh'
    },
    pressTabThermostat: {
        id: 'manage-device.press-tab-thermostat',
        defaultMessage:
            'Press the tab at the bottom of the thermostat and lift off the wall. Remove and then reinsert a battery, wait a couple of minutes and press refresh'
    },
    checkHasLight: {
        id: 'manage-device.check-has-light',
        defaultMessage: 'Check your boiler module has a light, if not, ensure mains power switch for boiler is on.'
    },
    hubGuideLinkText: {
        id: 'manage-device.hub-guide-link-text',
        defaultMessage: 'here'
    },
    naStep1: {
        id: 'manage-device.naStep1',
        defaultMessage: 'Remove the thermostat faceplate from the wall'
    },
    naStep2: {
        id: 'manage-device.naStep2',
        defaultMessage:
            'Check your wires are secure and in the correct terminals. {break} Tip: You can compare this to the photo you took when you installed your thermostat'
    },
    naStep3: {
        id: 'manage-device.naStep3',
        defaultMessage: 'Put the faceplate back on, confirm your wiring and tap refresh below'
    }
});



// WEBPACK FOOTER //
// ./src/core/i18n/components/widgets/device-offline/intl.js